export enum StoreTab {
  PRODUCTS = 'products',
  HISTORY = 'history',
}
